<!-- 
화면명 : UCCombo.vue
작성일 : 2025-07-01
설명   : 콤보 컨트롤
-->
<template>
  <div class="flex items-center space-x-2">
    <img src="@/assets/img/blue-circle.png" class="w-3 h-3" v-if="label" />

    <label
      class="text-blueGray-600 text-sm font-semibold whitespace-nowrap"
      v-if="label"
    >
      {{ label }}
    </label>
    <select
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
      class="flex-1 px-3 py-1 border border-blueGray-300 rounded text-sm text-blueGray-600 focus:ring-2 focus:ring-lightBlue-500"
      :style="{ width: widthStyle }"
    >
      <option
        v-for="forData in arrData"
        :key="forData[code]"
        :value="forData[code]"
      >
        {{ forData[name] }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed } from "vue";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  modelValue: {
    type: String,
    default: "",
    required: true,
  },
  arrData: {
    type: Array,
    required: true,
  },
  code: {
    type: String,
    default: "",
    required: true,
  },
  name: {
    type: String,
    default: "",
    required: true,
  },
  width: {
    type: [String, Number],
    default: "100%",
  },
});

const emit = defineEmits(["update:modelValue"]);

// width 계산
const widthStyle = computed(() => {
  return typeof props.width === "number" ? `${props.width}px` : props.width;
});
</script>
